import 'javascripts/all_pages.js'
import 'javascripts/all_theme_styles.js'
import('javascripts/comments');
import { jqTextExpander, jqTextCopy } from 'javascripts/general_scripts';
import { comparisonWidget } from "javascripts/product_comparisons/comparison_widget";

jqTextExpander();
jqTextCopy();
comparisonWidget();